import styled from "styled-components";

const Container = styled.section`
    width: 1056px;
    max-width: 100%;
    box-sizing: border-box;
    padding: ${({ theme }) => theme.containerPadding};
    margin: 0 auto;

    @media all and (max-width: ${({ theme }) => theme.mobileBreakingPoint}) {
        width: 100%;
    }
`;
export default Container;
